module.exports = __webpack_public_path__ + "media/images/lp_consultation/ic-free-dial-a72d5cc97970cdee6939af44b3762884.svg";